import { LANG } from 'constants/language.const';
import { useContext } from 'react'
import { AuthContext, AuthContextProps } from '../services/auth/AuthContext';

const useLang = (): { lang: LANG, localeCode: string, hardlang: { code: any }, setLang: (code: LANG) => void, setHardLang: (status: string) => void } => {
    const { lang, setLang, hardlang, setHardLang } = useContext<AuthContextProps>(AuthContext);
    let localeCode = lang as string;
    if (lang === LANG.NO) {
        localeCode = "nb";
    }
    return { lang, localeCode, setLang, hardlang, setHardLang };
}

export default useLang
